// extracted by mini-css-extract-plugin
export default {"processingContent":"modal-processing-album-payment_processingContent__I9MRw"};